import { createStyles, makeStyles } from '@material-ui/core';
import * as React from 'react';
import cn from 'classnames';
import { TranquiTheme } from '../../containers/App/theme';

interface LoaderProps {
  size?: number;
  color?: string;
  className?:string;
}

const Loader: React.FC<LoaderProps> = ({ size = 24, color = '#507FEE', className, ...props }) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <svg
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      width={size}
      height={size}
      className={cn(classes.root, className)}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="1.5" r="1.5" fill={color} />
      <circle cx="16.864" cy="4.13603" r="1.5" transform="rotate(45 16.864 4.13603)" fill={color} />
      <circle cx="19.5" cy="10.5" r="1.5" transform="rotate(90 19.5 10.5)" fill={color} />
      <circle cx="16.864" cy="16.864" r="1.5" transform="rotate(135 16.864 16.864)" fill={color} />
      <circle cx="10.5" cy="19.5" r="1.5" fill={color} />
      <circle cx="4.13599" cy="16.864" r="1.5" transform="rotate(45 4.13599 16.864)" fill={color} />
      <circle cx="1.5" cy="10.5" r="1.5" transform="rotate(90 1.5 10.5)" fill={color} />
      <circle cx="4.136" cy="4.13605" r="1.5" transform="rotate(135 4.136 4.13605)" fill={color} />
    </svg>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    animation: 'rotation 5s ease-in-out infinite',
  },
}));

export default Loader;
